import {
  ControlWithDescription,
  InlineWithDescription,
} from 'components/form-layouts';
import { useAbility } from '@cast/shared-ability-data-access';
import { CUSTOM_EDGE_PROVIDER } from 'features/cluster/autoscaler/edge-locations/constants';
import { EdgeLocationProvider } from 'features/cluster/autoscaler/edge-locations/types';
import { makeEdgeLocationDrawerLink } from 'features/cluster/autoscaler/navigation';

import { RffSelect } from '@cast/shared-rff-ui';

import { ExternalLink, Typography, Stack, tokens } from '@cast/design-system';

export const EdgeLocationSection = ({
  isCreateMode,
  edgeLocationOptions,
  clusterId,
}: {
  isCreateMode: boolean;
  edgeLocationOptions: Array<{
    id: string;
    name: string;
    provider: EdgeLocationProvider;
  }>;
  clusterId: string;
}) => {
  const canCreateEdgeLocation = useAbility().can(
    'create',
    'ClusterEdgeLocations'
  );
  const hasEdgeLocationOptions = edgeLocationOptions.length > 0;

  return (
    <InlineWithDescription
      description={
        <ControlWithDescription label="Edge location">
          To configure additional edge nodes, select an edge location and adjust
          its settings.
        </ControlWithDescription>
      }
      controls={
        <RffSelect
          name="edgeLocationId"
          label="Edge location"
          inputProps={{
            placeholder: 'Select edge location',
          }}
          disabled={!isCreateMode}
          options={edgeLocationOptions}
          optionDisabled={(option) => option.provider === CUSTOM_EDGE_PROVIDER}
          optionValue="id"
          optionLabel="name"
          testId="edge-location-select"
          Footer={
            canCreateEdgeLocation && (
              <Stack
                px={12}
                py={10}
                borderTop="1px solid"
                borderColor={tokens.theme.border.structural.neutral}
              >
                <Typography
                  variant="P12M"
                  color={tokens.theme.fg.structural.secondary}
                >
                  {hasEdgeLocationOptions
                    ? 'Need another region?'
                    : 'No edge locations found'}
                </Typography>
                <ExternalLink
                  sx={{ typography: 'P10M' }}
                  link={makeEdgeLocationDrawerLink({
                    clusterId,
                  })}
                >
                  Create a new edge location
                </ExternalLink>
              </Stack>
            )
          }
        />
      }
    />
  );
};
